import styled from 'styled-components';

export const Container = styled.span`
  width: fit-content;
  font-size: 0.875rem;
  font-weight: 400;

  color: #191919;

  margin-top: 1rem;
  a {
    color: #a6a5a1;
    margin-left: 0.5rem;
  }
`;
